
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiGrid extends Serenity.EntityGrid<ProdottiRow, any> {
        protected getColumnsKey() { return ProdottiColumns.columnsKey; }
        protected getDialogType() { return ProdottiClonableDialog; }
        protected getIdProperty() { return ProdottiRow.idProperty; }
        protected getInsertPermission() { return ProdottiRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiRow.localTextPrefix; }
        protected getService() { return ProdottiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            // force new and edit item dialogs to open in panel mode
            this.openDialogsAsPanel = true;
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            //columns.unshift({
            //    field: 'Esperienze',
            //    name: '',
            //    format: ctx => '<a class="inline-action goto-utenti" title="Utenti">' +
            //        '<i class="fa fa-user-plus text-green"></i></a>',
            //    width: 24,
            //    minWidth: 24,
            //    maxWidth: 24
            //});

            // Add column
                columns.unshift({
                    field: 'SMTP',
                    name: '',
                    format: ctx => {
                        var htmlForIcon = '<a class="inline-action goto-smtp" title="Configurazione SMTP"><i class="fa fa-at text-green"></i></a>';
                        var htmlForIconNotValid = '<a class="inline-action goto-smtp" title="Configurazione SMTP"><i class="fa fa-at text-red"></i></a>';
                        var item: ProdottiRow = ctx.item;
                        if (item.IsSMTPValido === 1)
                            return htmlForIcon;
                        else
                            return htmlForIconNotValid;
                    },
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                // Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            }

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('goto-utenti')) {
                    new Gamification.ProdottiEsperienzeDialog().loadByIdAndOpenDialog(item.IdProdotto);
                }

                if (target.hasClass('goto-smtp')) {
                    new Gamification.ProdottiSmtpDialog().loadByIdAndOpenDialog(item.IdProdotto);
                }
            }
        }
    }
}